module.exports = __webpack_public_path__ + "media/images/emblems/Farnern-coat_of_arms-da2ca5e70640a65726a309b69983e3f7.svg";